var React = require('react');

function IconCloseX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.654 32c0 0-13.571-13.571-13.571-13.571s-13.738 13.571-13.738 13.571c0 0-2.346-2.346-2.346-2.346s13.738-13.571 13.738-13.571c0 0-13.738-13.738-13.738-13.738s2.346-2.346 2.346-2.346c0 0 13.738 13.738 13.738 13.738s13.571-13.738 13.571-13.738c0 0 2.346 2.346 2.346 2.346s-13.571 13.738-13.571 13.738c0 0 13.571 13.571 13.571 13.571s-2.346 2.346-2.346 2.346"}));
}

IconCloseX.defaultProps = {"version":"1.1","width":"22","height":"22","fill":"white","viewBox":"0 0 32 32"};

module.exports = IconCloseX;

IconCloseX.default = IconCloseX;
